import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./Build_With_Us_Modal.css";
import Select from "react-select";
import Successfull_Lottie from "../../../animation/Successfull_Lottie/Successfull_Lottie";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import Submit_Btn from "../../common_btn/submit_btn/Submit_Btn";

const Build_With_Us_Modal = (props) => {
  const navigate = useNavigate();
  // Fetch city list

  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Contact No</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.contact_no}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">City</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.city}</td>
            </tr>
             <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Type Of Project</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.project_type?.label}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const payload = {
        email: "techinteriorsanddesigners@gmail.com",
        subject: "demo",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "http://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setFormSubmitted(true);
        setTimeout(() => {
          navigate("/");
          setFormSubmitted(false);
        }, 3000);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const serviceOptions = [
    {
      value: "furniture-custom-carpentry",
      label: "Furniture & Custom Carpentry",
    },
    { value: "modular-kitchens", label: "Modular Kitchens" },
    {
      value: "acoustic-theatre-design",
      label: "Acoustic & Home Theatre Design",
    },
    { value: "civil-renovation-work", label: "Civil & Renovation Work" },
    { value: "false-ceiling-designs", label: "False Ceiling & POP Designs" },
    {
      value: "professional-painting-services",
      label: "Professional Painting Services",
    },
    { value: "home-automation", label: "Home Automation" },
    {
      value: "3D-designing-visualization",
      label: "3D Designing & Visualization",
    },
  ];
  const [formSubmitted, setFormSubmitted] = useState(false);

  return (
    <Modal className="Build_With_Us_Modal" size="lg" {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Build with Us
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="build_form_div">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="input_group">
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter Full Name*"
                {...register("name", {
                  required: "Full Name is required",
                })}
                className={classNames("", {
                  "is-valid": getValues("name"),
                })}
              />
              {errors?.name && (
                <span className="invalid-feedback d-block">
                  {errors.name.message}
                </span>
              )}
            </Form.Group>

            <Form.Group className="input_group">
              <Form.Control
                type="text"
                name="email"
                placeholder="Enter Email*"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    message: "Invalid email address",
                  },
                })}
                className={classNames("", {
                  "is-invalid": errors?.email,
                  "is-valid": getValues("email"),
                })}
              />
              {errors?.email && (
                <span className="invalid-feedback d-block">
                  {errors.email.message}
                </span>
              )}
            </Form.Group>

            <Form.Group className="input_group">
              <Controller
                country="in"
                name="contact_no"
                control={control}
                rules={{
                  required: "Contact No is required",
                  minLength: {
                    value: 10,
                    message: "Number should be at least 10 characters",
                  },
                }}
                render={({ field }) => (
                  <PhoneInput
                    country={"in"}
                    {...field}
                    className={classNames("", {
                      "is-invalid": errors?.contact_no,
                      "is-valid": getValues("contact_no"),
                    })}
                    onChange={(value) => field.onChange(value)}
                    type="text"
                    placeholder="Enter Contact Number*"
                    maxLength={10}
                  />
                )}
              />
              {errors?.contact_no && (
                <span className="invalid-feedback d-block">
                  {errors.contact_no.message}
                </span>
              )}
            </Form.Group>

            <Form.Group
              className="input_group"
              controlId="exampleForm.ControlInput1"
            >
              <Form.Control
                type="text"
                name="city"
                placeholder="Enter City"
                {...register("city", {
                  required: "City is required",
                })}
                className={classNames("", {
                  "is-valid": getValues("city"),
                })}
              />
              {errors?.name && (
                <span className="invalid-feedback d-block">
                  {errors.city.message}
                </span>
              )}
            </Form.Group>

            <Form.Group className="input_group">
              <Controller
                name="project_type"
                control={control}
                rules={{ required: "Type of Project is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    placeholder="Type of Project"
                    options={serviceOptions}
                    styles={{
                      control: (base) => ({
                        ...base,
                        // borderColor: errors.city ? "red" : base.borderColor,
                      }),
                    }}
                  />
                )}
              />
              {errors?.project_type && (
                <span className="invalid-feedback d-block">
                  {errors.project_type.message}
                </span>
              )}
            </Form.Group>

            <Form.Group className="input_group">
              <Form.Control
                as={"textarea"}
                type="text"
                name="message"
                placeholder="Write your message here"
                {...register("message", {
                  required: "Message is required",
                })}
                className={classNames("", {
                  "is-invalid": errors?.message,
                  "is-valid": getValues("message"),
                })}
              />
              {errors?.message && (
                <span className="invalid-feedback d-block">
                  {errors.message.message}
                </span>
              )}
            </Form.Group>

            {!formSubmitted ? (
              <div className="send_btn_div">
                <Submit_Btn
                  btn_name="Submit"
                  type="submit"
                // onClick={() => {
                //   setFormSubmitted(true);

                //   setTimeout(() => {
                //     navigate("/");
                //     setFormSubmitted(false);
                //   }, 3000);
                // }}
                />
              </div>
            ) : (
              <div className="success_div">
                <Successfull_Lottie successText="Message Sent Successfully" />
              </div>
            )}
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Build_With_Us_Modal;
